<template>
    <v-container>
        <h1 class="titulo mb-3">Relatório de Rascunhos Expurgados</h1>
        <v-card>
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ rotate90: filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="downloadReport">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" class="mt-8" v-show="filter_open">
                        <v-row>
                            <v-col cols="12" md="6">
                                <DateRange :not-after-today-habilitado="true" v-model="filters.dataRange" @filter="filtrar() "
                                           :shortcut="true" label="Data de execução de expurgo" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select id="FieldCategoria" label="Categoria: " outlined menu-props="offsetY" :items="categorias" hide-details v-model="filters.categoria" placeholder="Selecione a categoria" item-text="name" item-value="value" />
                            </v-col>
                        </v-row>
                        <v-row class="justify-end">
                            <v-col cols="6" sm="3">
                                <v-btn color="secondary" block @click="limparFiltro">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="3">
                                <v-btn color="primary" block @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <br />
                <DataTable url="/painel/logs/listar_expurgos" :headers="headers" @onLoad="itensCarregados" :params="params" item-key="id" :value="logs_selecionados" class="listagem text-center" ref="datatable" :filter="search">
                    <template v-slot:items="{item}">
                        <td>{{ item.data_expurgo }}</td>
                        <td>{{ item.categoria }}</td>
                        <td>
                            <v-icon small @click="baixarRelatorio(item.id)" class="cursor-pointer">mdi-file-download-outline</v-icon>
                        </td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
        <br />
    </v-container>
</template>
<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../plugins/alerts_types'
  import * as Qs from 'qs'

  export default {
    name: 'RelatorioExpurgos',
    data: () => ({
      headers: [
        { text: 'Data do Expurgo', value: 'data_expurgo', align: 'center' },
        { text: 'Categoria', value: 'categoria', align: 'center', sortable: false },
        { text: 'Download Relatório', value: 'relatorio_path', align: 'center', sortable: false }
      ],
      custom_filter: {},
      filter_open: false,
      filters: {
        dataRange: ['', ''],
        categoria: ''
      },
      search: {},
      page: 1,
      itemsPerPage: 15,
      items: [],
      logs_selecionados: [],
      totalItems: null,
      categorias: ['Manual', 'Automático']
    }),
    computed: {
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'tb_expurgo_logs.data_expurgo',
            descending: true,
            totalItems: 0
          },
          custom_filter: this.customFilter
        }
      }
    },
    methods: {
      limparFiltro () {
        this.$refs.filter.reset()
        this.search = {}
        this.$refs.datatable.reload()
      },
      filtrar () {
        this.page = 1
        if (this.$refs.filter.validate()) {
          this.search = { ...this.filters }
        }
      },
      downloadReport () {
        const filtros = { ...this.filters }
        const headersExport = this.headers
          .filter(h => h.value && h.value !== 'relatorio_path')
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value && h.value !== 'relatorio_path')
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: 'tb_expurgo_logs.data_expurgo', descending: true },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/relatorios_propostas_log/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      itensCarregados (items) {
        this.items = items
      },
      baixarRelatorio (id) {
        const url = `/painel/expurgo/download?id=${id}`

        this.$http.get(url, { responseType: 'blob' })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))

            const log = this.items.find(item => item.id === id)
            const fileName = log ? log.relatorio_path.split('/').pop() : `relatorio_expurgo_${id}.xlsx`

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            link.remove()
          })
          .catch(error => {
            if (error.response && error.response.status === 404) {
              notification(AlertTypes.ERROR, 'Arquivo de relatório não encontrado. Por favor, tente novamente posteriormente ou entre em contato com a área de suporte.')
            } else {
              notification(AlertTypes.ERROR, error, 'Erro ao baixar o relatório. Por favor, tente novamente.')
            }
          })
      }
    }
  }
</script>
<style scoped>

.cursor-pointer {
  font-size: 26px!important
}
</style>
